import { ISupersetStoreSegment } from './superset.interface';

export const supersetStoreSelector = (state: ISupersetStoreSegment) => state.superset;
